import { lazy, React, Suspense, useEffect } from "react";
import { Link, Route, Routes, useLocation } from 'react-router-dom'
import { useParams } from 'react-router-dom';

import AOS from 'aos';
import 'aos/dist/aos.css';
import NavBar from './NavBar.js';
import Home from './pages/Home.js';

import Signup from './pages/Signup.js';
import Login from './pages/Login.js';
import ForgotPassword from './pages/ForgotPassword.js';

const Classes = lazy(() => import("./pages/Classes.js"))
const Practice = lazy(() => import("./pages/Practice.js"))
const Contests = lazy(() => import("./pages/Contests.js"))
const Career = lazy(() => import("./pages/Career.js"))
const Contact = lazy(() => import("./pages/Contact.js"))
const Team = lazy(() => import("./pages/Team.js"))
const License = lazy(() => import("./pages/License.js"))
const Notfound = lazy(() => import("./pages/Notfound.js"))
const Battle = lazy(() => import("./pages/Battle.js"))
const ChatRoom = lazy(() => import("./pages/ChatRoom.js"))
const PdfArchives = lazy(() => import("./pages/pdfArchives.js"))
const Profile = lazy(() => import("./pages/Profile.js"))
const Ranking = lazy(() => import("./pages/Ranking.js"))


export function backToTop(mybutton) {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
    } else {
        mybutton.style.display = "none";
    }
}

export const Copyright = () => {
    return (
        <footer id='footer'>
            <div id='footerdiv'>
                    <Link to='/'>Home</Link>
                    <Link to='/classes'>Classes</Link>
                    <Link to='/practice'>Practice</Link>
                    <Link to='/contests'>Contests</Link>
                    <Link to='/team'>Our Team</Link>
            </div>
        </footer>
    )
}

function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

function PracticeWithTopic() {
    const { topic } = useParams();

    const categoryMap = {
        "arithmetic": "Arithmetic",
        "algebra": "Algebra",
        "geometry": "Geometry",
        "numbertheory": "Number Theory",
        "number theory": "Number Theory",
        "combinatorics": "Combinatorics",
        "precalculus": "PreCalculus"
    };

    const catName = categoryMap[topic.toLowerCase()];
    if (catName) {
        return <Practice category={catName} />;
    }

    return <Practice selectedTopic={topic} />;
}

const App = () => {

    AOS.init();

    return (
        <>
            <ScrollToTop />
            <NavBar />

            <Suspense fallback={<div className="lazy-preloader"></div>}>
                <div className='page'>
                    <Routes>
                        <Route exact path='/' element={<Home />} />
                        <Route exact path='/classes' element={<Classes />} />
                        <Route exact path='/practice/:topic' element={<PracticeWithTopic />} />
                        <Route exact path='/practice' element={<Practice />} />
                        <Route exact path='/contests' element={<Contests />} />
                        <Route exact path='/license' element={<License />} />
                        <Route exact path='/careers' element={<Career />} />
                        <Route exact path='/contact' element={<Contact />} />
                        <Route exact path='/team' element={<Team />} />
                        <Route exact path='/battle' element={<Battle />} />
                        <Route exact path='/chatroom' element={<ChatRoom />} />
                        <Route exact path='/pdfArchives' element={<PdfArchives />} />
                        <Route exact path='/profile' element={<Profile />} />
                        <Route exact path='/profile/:userId' element={<Profile />} />
                        <Route exact path='/ranking' element={<Ranking />} />

                        <Route exact path='/signup' element={<Signup />} />
                        <Route exact path='/login' element={<Login />} />
                        <Route exact path='/forgot-password' element={<ForgotPassword />} />
                        <Route exact path='/*' element={<Notfound />} />
                    </Routes>
                </div>
            </Suspense>

            <Copyright />
        </>
    );
}

export default App;
